/**
 * UnitToggle — botões pill com unidade ativa.
 *
 * Mockup 20 Etapa 2: combustíveis aceitam R$, km ou L (caso transporte
 * público: R$, km ou # viagens). Usado em conjunto com `FuelInput` da
 * etapa de deslocamento.
 */
import type { FuelUnit } from '../api/types';

interface UnitToggleProps {
  units: FuelUnit[];
  active: FuelUnit | '';
  onChange: (u: FuelUnit) => void;
}

const UNIT_LABELS: Record<FuelUnit, string> = {
  BRL: 'R$',
  km: 'Km',
  L: 'L',
  // "viag" = número total de viagens (não litros). Transporte público
  // colaborador não consome combustível direto — quem queima é a operadora.
  trips: 'viag',
  kWh: 'kWh',
};

export function UnitToggle({ units, active, onChange }: UnitToggleProps) {
  return (
    <div role="group" className="inline-flex rounded-md border border-areia bg-cream/40 p-0.5">
      {units.map((u) => {
        const isActive = u === active;
        return (
          <button
            key={u}
            type="button"
            onClick={() => onChange(u)}
            className={
              'px-2.5 py-1 text-xs font-medium rounded transition-colors ' +
              (isActive
                ? 'bg-floresta text-cream'
                : 'text-tabaco hover:text-floresta')
            }
            aria-pressed={isActive}
          >
            {UNIT_LABELS[u]}
          </button>
        );
      })}
    </div>
  );
}
